import React, { useEffect, useState } from "react";
import { intl } from "LocaleWrapper";
import { Language, usePermission } from "../../imports/Utils";
import { gql } from "__generated__/gql";
import { useMutation } from "@apollo/client";
import { DeclareWithRemarkDocument } from "__generated__/view/declarations/graphql/declaration.mutations.generated";
import moment from "moment";
import { Button, showSnackbar, Textarea } from "@cofano/cck";

const mutation = gql(`#graphql
	mutation saveRemark($id: Long!, $remark: String!) {
		saveRemark(id: $id, remark: $remark) {
			id
		}
	}
`);

const Remark = ({ charter, refetch, window }) => {

	const [ remark, setRemark ] = useState();
	const { isReadOnly } = usePermission();
	const isDeclarationPresent = charter?.declarations?.[0];

	const [ save, { loading: declareLoading } ] = useMutation(mutation, {
		onCompleted: () => {
			refetch();
			showSnackbar(intl.formatMessage({ id: "SUCCESSFUL_SAVED" }), { variant: "success" });
		},
	});

	const [ declare ] = useMutation(DeclareWithRemarkDocument);

	useEffect(() => {
		if (isDeclarationPresent) {
			setRemark(charter.declarations[0].remark);
		} else {
			setRemark(undefined);
		}
	}, [ charter ]);

	const saveRemark = async() => {
		let declarationId;
		if (charter?.declarations?.[0]?.id) {
			declarationId = charter.declarations[0].id;
		} else {
			await declare({
				variables: {
					input: {
						id: charter?.declarations?.[0]?.id,
						charterId: charter.id,
						from: moment(window.from).unix() * 1000,
						to: moment(window.to).unix() * 1000,
						shipId: charter.ships?.[0]?.id,
					},
				},
			}).then(response => {
				declarationId = response.data.declare.id;
			});
		}
		save({ variables: { id: declarationId, remark } });
	};

	return <div className="declaration-remark">
		<React.Fragment>
			<h3>{Language("DECLARATION_REMARK")}</h3>
			<Textarea
				value={remark}
				onChange={event => setRemark(event.target.value)}
				disabled={isReadOnly} />
			<Button
				onClick={() => saveRemark()}
				loading={declareLoading}
				disabled={declareLoading || isReadOnly}
				variant="outlined"
				size="small">
				{Language("SAVE")}
			</Button>
		</React.Fragment>
	</div>;
};

export default Remark;
